import React from 'react';
import { Avatar } from 'library/ui';
import { ImgContainer } from './Containers';

const ProfileImage = ({ image, imageId, initials }: { image?: string; imageId: string; initials?: string }) => {
    return (
        <ImgContainer>
            <span id={imageId}>
                <Avatar imageUrl={image} initials={initials} size={120} />
            </span>
        </ImgContainer>
    );
};

export default ProfileImage;
